export default {
  notification: null,
};
